import { Button, Col, Dropdown, Menu, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import RecentCarosel from "./recentReceivedCarosel";
import { getBalance, getCoins } from "./service";
import NumberFormat from "react-number-format";
import Loader from "../../shared/loader";
import AppAlert from "../../shared/appAlert";
import SpinLoader from "../../shared/spinLoader";
import { useDispatch, useSelector } from "react-redux";
import { fetchCommissionDeatails } from "../../reducers/transferReducer";
const { Paragraph,Text } = Typography;
const WalletType = process.env.REACT_APP_WALLET_TYPE;

const BalanceView = () => {
    const reducerDispatch = useDispatch();
    const customerInfo = useSelector((store) =>store.userConfig.userProfileInfo)
    const [coinDetails, setCoinDetails] = useState(null);
    const [coinsList, setCoinList] = useState([]);
    const [selectedCoin, setSelectedCoin] = useState();
    const [error, setError] = useState(null);
    const [loader, setLoader] = useState(false);
    const history = useHistory()
    const [dropdownLoader, setDropdownLoader] = useState(false);
    const commisionsData = useSelector((store) => store.trasferReducer.commissionDetails);
    useEffect(() => {
        getCustomerCoins();
    }, [])
    useEffect(() => {
        if (selectedCoin) {
            getAvailableBalance(selectedCoin)
        }
    }, [selectedCoin])
    const getAvailableBalance = async (coinName) => {
        try {
            setLoader(true);
            let response = await getBalance(coinName,customerInfo?.id);
            setCoinDetails(response);
        }
        catch (errors) {
            setError(errors);
        }
        finally {
            setLoader(false);
        }
    }
    const getCustomerCoins = async () => {
        try {
            setDropdownLoader(true);
            let response = await getCoins('Merchant/coinslookup');
            setCoinList(response?.Coins);
            setSelectedCoin(response?.Coins[0]?.name)
        }
        catch (coinsError) {
            setError(coinsError);
        }
        finally {
            setDropdownLoader(false);
        }
    }
    const handleCoins = (coinDts) => {
        setSelectedCoin(coinDts?.name)
    }
    const menu = (
        <Menu>
            <ul className="dropdown-list">
                {coinsList?.length > 0 &&
                    coinsList.map((item) => (
                        <li key={item?.name} className="c-pointer">
                            <Button onClick={() => handleCoins(item)} className="customicon c-pointer transparent-btn d-flex align-items-center gap-4">
                                <span className={`crypto coin sm ${item?.name?.toLowerCase()}`}></span>
                                <span>{item?.name}</span>
                            </Button>
                        </li>
                    ))}
            </ul>
        </Menu>
    );
    const handleFontSize = (amount) => {
        const cardBalance = amount?.toString();
        return cardBalance && cardBalance.length >= 9 ? 'fs36' : '';
      };
    const GoToTransfer = async () => {
        // if (WalletType !== 'non_custodial') {
        //     history.push('/transfer');
        // } else {
        //     reducerDispatch(fetchCommissionDeatails(customerInfo?.id, (response) => {
        //         if (response.ok) {
        //             if (response.data?.commissionAmount) {
        //                 history.push('/pendingcommissions');
        //             } else {
        //                 history.push('/transfer');
        //             }
        //         } else {
        //             setError(response)
        //         }
        //     }));
        // }
        history.push('/transfer');
    }

    return (
             <Row gutter={[16, 16]} className="pannel-bg mx-0" >
            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12} className="col-space">
            {error  && (
            <div className="alert-flex" style={{ width: "100%" }}>
                <AppAlert
                    className="w-100 "
                    type="warning"
                    description={error}
                    showIcon
                />
                <span className="icon sm alert-close" onClick={() => setError(null)}></span>
            </div>
        )}
        <label className="label-style">Available Balance</label>
              {loader && <Loader />}
               { !loader && <div className="d-md-flex align-items-start">
                    <div>
                    <div className="d-flex align-items-center">
                        <Paragraph className={`avail-balance ${handleFontSize(coinDetails?.amount)}`}>{coinDetails?.code}{"  "}
                            <NumberFormat value={parseFloat(coinDetails?.amount).toFixed(4)} displayType="text" thousandSeparator={true} />
                        </Paragraph>
                        {(dropdownLoader && !loader) ? <SpinLoader/> : <Dropdown overlay={menu} className="ml-8" overlayClassName="coin-select-overlay" >
                            <a className="d-flex align-items-center">
                                <span className="icon sm downarrow"></span>
                            </a>
                        </Dropdown>}
                    </div>
                    {!loader && <Text className="usd-today-value"><span className="icon sm negation"></span>$<NumberFormat value={parseFloat(coinDetails?.amountInUSD).toFixed(2)} displayType="text" thousandSeparator={true} /></Text>}
                    </div>
                    <Button loading={commisionsData?.isLoader} className="btn-style tranfer-btn" onClick={GoToTransfer} >
                        <span> Transfer</span>
                        <span className="cion"></span>
                    </Button>
                </div>}
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12} className="border-left">
                <Paragraph className="card-title slide-top-space">Recent Transactions</Paragraph>
                <RecentCarosel />
            </Col>
        </Row>
    )
}
export default BalanceView
